import { render, staticRenderFns } from "./MaxiflameMaxifresh_1d02_P30.vue?vue&type=template&id=2285998e&"
import script from "./MaxiflameMaxifresh_1d02_P30.vue?vue&type=script&lang=js&"
export * from "./MaxiflameMaxifresh_1d02_P30.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports